require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/tero.alen/Dev/ajantasalla/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tero.alen/Dev/ajantasalla/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tero.alen/Dev/ajantasalla/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/tero.alen/Dev/ajantasalla/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/tero.alen/Dev/ajantasalla/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tero.alen/Dev/ajantasalla/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./en.js") })
        }
      }, "component---src-pages-en-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-en-js!./src/pages/en.js
// module id = 389
// module chunks = 231608221292675